import { render } from "./CatalogGridCard.vue?vue&type=template&id=4b064a23"
import script from "./CatalogGridCard.vue?vue&type=script&lang=js"
export * from "./CatalogGridCard.vue?vue&type=script&lang=js"

import "./CatalogGridCard.vue?vue&type=style&index=0&id=4b064a23&lang=scss"
script.render = render

export default script